import en from './en';
import nl from './nl';

const list = ['en', 'nl'];

export default { en, nl, list };